module.exports = __webpack_public_path__ + "static/media/customer.8d27d0b0.svg";